module.exports = __webpack_public_path__ + "media/toolkits/HVAC-mobile-ecosystem-c4fd9be1.jpg";